import { useState, useEffect } from 'react';
import { changeLanguage } from 'i18next';
import localforage from 'localforage';

type Language = 'ja' | 'en';

export const useLanguage = (): [Language | undefined, () => void] => {
    const [lang, setLang] = useState<Language>();

    useEffect(() => {
        setTimeout(() => {
            localforage.getItem(
                'lang',
                (_: unknown, value: Language | null) => {
                    setLang(value || 'ja');
                }
            );
        });
    }, []);

    const handleLangChange = () => {
        localforage.getItem('lang', (err: unknown, value: Language | null) => {
            if (err) {
                changeLanguage('ja');
                localforage.setItem('lang', 'ja');
                setLang('ja');
                return;
            }
            const nextLang = value === 'ja' ? 'en' : 'ja';
            changeLanguage(nextLang);
            localforage.setItem('lang', nextLang);
            setLang(nextLang);
        });
    };

    return [lang, handleLangChange];
};
